// import { yupResolver } from "@hookform/resolvers/yup";
// import { useForm } from "react-hook-form";
// import { ticketValidation } from "../../utils/validations/formValidations";
// import MessageIcon from '../../assets/message.png';
import EmailIcon from '../../assets/email.svg';
import { Drawer, message } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { SendEmail } from "../../utils/api";
import ReactQuill from 'react-quill';

const TicketDetails = ({ ticketDrawerData: { visible, data }, setTicketDrawerData }) => {
  const [loading, setLoading] = useState(false);
  const [emailText, setEmailText] = useState("");

  // const { register, handleSubmit, formState: { errors, isValid }, reset } = useForm({ resolver: yupResolver(ticketValidation) });

  const handleEmailChange = (_content, _delta, _source, editor) => {
    setEmailText(editor.getHTML());
  };

  const onSubmit = async () => {
    message.destroy()
    const mailData = {
      email: data?.user?.email,
      message: emailText.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>')
    }
    if (emailText.length !== 0 && emailText !== "<p><br></p>") {  
      try {
        setLoading(true);
        const resData = await SendEmail(mailData);
        if (resData?.isSuccess) {
          setEmailText("")
          message.success(`Mail sent to ${data?.user?.email}`);
          setTicketDrawerData({ visible: false, data: null });
        } else {
          message.destroy();
          message.error(resData?.error);
        }
      } catch (error) {
        message.error('An error occurred during the process. Please try again later.');
      } finally {
        setLoading(false);
      }
    } else {
      message.error('Email is required.');
    }
  }

  const handleCancel = () => {
    setTicketDrawerData({ visible: false, data: null });
    setEmailText("")
  }

  return (
    <Drawer contentWrapperStyle={{ width: "500px" }} className="send-email_drawer" title="Ticket Details" placement="right" onClose={() => setTicketDrawerData({ visible: false, data: null })} open={visible}>
      <div className="w-full bg-primary-300">
        <div className="w-full flex flex-col gap-y-3 px-4 ml-5 py-3 border-bottom">

          <div className="w-[90%] flex flex-col gap-y-3 text-xs font-medium">
            <div className="flex mt-1">
              <span className="w-20 flex-shrink-0">Subject:</span>
              <span className="text-black-500 break-all max-h-24 no-scrollbar overflow-y-scroll">{data?.subject}</span>
            </div>
            <div className="flex">
              <span className="w-20">Message:</span>
              <span className="text-black-500 flex-1 max-h-36 no-scrollbar overflow-y-scroll">{data?.message}</span>
            </div>
            <div className="flex">
              <span className="w-20 flex-shrink-0">Created on:</span>
              <span className="text-black-500 whitespace-nowrap">{dayjs(data?.created_at).format('DD MMM YYYY, h:mma')}</span>
            </div>
            <div className="flex mb-1">
              <span className="w-20 flex-shrink-0">Email:</span>
              <div className="flex gap-x-1 items-center">
                <img src={EmailIcon} alt="email" width={12} />
                <span className="-mt-1 text-black-500">{data?.user?.email}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="px-9 py-4">
        {/* <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)} noValidate> */}
        {/* <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative mt-2">
            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="subject">Subject</label>
            <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

              <g id="SVGRepo_bgCarrier" stroke-width="0" />

              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

              <g id="SVGRepo_iconCarrier"> <path d="M4 12H20M4 8H20M4 16H12" stroke="#797979" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /> </g>

            </svg>
            <input className="w-full outline-none text-[12px] text-input-placeholder" type="text" id="subject" {...register('subject')} />
          </div>
          <p className="text-[red] text-[12px]">{errors.subject?.message}</p> */}
        {/* <div className="border border-input-placeholder flex items-start gap-x-2 rounded-lg p-3 relative mt-4">
            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="message">Response</label> */}
        {/* <img src={MessageIcon} alt="message-svg" width={12} /> */}
        {/* <textarea className="w-full outline-none text-[12px] text-input-placeholder resize-none no-scrollbar" rows={6} type="text" id="message" {...register('message')} /> */}
        <ReactQuill
          id="message"
          value={emailText}
          onChange={handleEmailChange}
          modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
          }}
          formats={[
            'header',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet',
          ]}
          placeholder="Write your email here..."
        />
        {/* </div> */}
        {/* <p className="text-[red] text-[12px]">{errors.message?.message}</p> */}

        <div className="mt-6 flex items-center justify-center gap-x-3">
          <span className=" bg-white flex-1 text-center text-primary-700 border border-primary-700 text-[10px] px-6 py-3 rounded-lg cursor-pointer" onClick={handleCancel}>Back</span>
          <button type="button" onClick={onSubmit} disabled={loading} className="flex-1 text-center bg-primary-700 border border-primary-700 text-white text-[10px] px-6 py-3 rounded-lg cursor-pointer flex items-center justify-center gap-x-2">
            Reply
            {loading && <span className="loader"></span>}
          </button>
        </div>
        {/* </form> */}
      </div >
    </Drawer >
  )
}

export default TicketDetails;